/**
 * The rank a new classification's form opens with: low in the estate, among the network devices,
 * where the form has always started. Worked out from the ranks that exist rather than written as a
 * number, because the scale is the data's: the shipped ranks were re-spaced tenfold (6 Oct 2026) so
 * that a customer has room to place a classification between any two of them.
 */
export function startingRank(rows: ReadonlyArray<{ DisplayRank: number | string }>): number {
    const ranks = rows.map((r) => Number(r.DisplayRank)).filter((n) => Number.isFinite(n) && n > 0)
    return ranks.length ? Math.min(...ranks) * 5 : 100
}
